import {Alert, alpha, Theme, useMediaQuery} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, {Dispatch, FC, SetStateAction,} from "react";
import {Trans, useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import {StorageConstants} from "../../../../util/constants";
import {IosShareOutlined} from "@mui/icons-material";

interface IProps {
    promptInstall: any
    setOpenPwaBanner: Dispatch<SetStateAction<boolean>>
    isIOS: boolean
}

const InstallPwaBanner: FC<IProps> = ({promptInstall, setOpenPwaBanner, isIOS}) => {
    const theme = useTheme()
    const {t} = useTranslation()
    const matchesMd = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"))

    const handleInstallClick = (evt: any) => {
        evt.preventDefault();
        if (promptInstall) {
            promptInstall.prompt();
            promptInstall.userChoice
                .then((choiceResult: any) => {
                    if (choiceResult.outcome === 'accepted') {
                        setOpenPwaBanner(false)
                    }
                })
        }
    };

    const handleCloseClick = () => {
        localStorage.setItem(StorageConstants.PWA_PROMPT_RESPONSE, new Date().toISOString())
        setOpenPwaBanner(false)
    }

    return <Alert icon={false} action={
        <Box whiteSpace="nowrap">
            <Button variant='outlined' size={matchesMd ? 'large' : 'medium'}
                    color='secondary'
                    sx={{whiteSpace: 'nowrap', ml: matchesMd ? '1.25em' : '0.5em'}}
                    onClick={handleCloseClick}>{t('close')}</Button>
            {!isIOS && <Button variant='contained' size={matchesMd ? 'large' : 'medium'}
                               color='secondary'
                               sx={{whiteSpace: 'nowrap', ml: '0.5em'}}
                               onClick={handleInstallClick}>{t('install')}</Button>}
        </Box>
    }
                  sx={{
                      position: 'fixed',
                      bottom: '1.25em',
                      left: '50%',
                      flexDirection: {xs: 'column', sm: 'row'},
                      transform: 'translate(-50%)',
                      width: {xs: '90%', sm: '80%', md: '60%', lg: '50%'},
                      zIndex: theme.zIndex.drawer - 1,
                      backgroundColor: alpha(theme.palette.primary.main, .8),
                      boxShadow: 5,
                      backdropFilter: 'blur(5px)',
                      color: theme.palette.secondary.main,
                      alignItems: 'center',
                      '& .MuiAlert-action': {
                          p: 0,
                          mr: {xs: 'auto', sm: 0}
                      },
                      '& .MuiAlert-message': {
                          width: '100%',
                          textAlign: {xs: 'center', sm: 'left'}
                      },
                  }}>
        <Typography color="secondary" variant={matchesMd ? 'subtitle1' : 'subtitle2'} fontWeight={600}>
            {t('get_for_seamless_experience')}
        </Typography>
        {isIOS && <Typography color="secondary" variant={matchesMd ? 'subtitle1' : 'subtitle2'} mt={1} sx={(theme) => ({
            fontSize: matchesMd
                ? `calc(${theme.typography.subtitle1.fontSize} * 0.9)`
                : `calc(${theme.typography.subtitle2.fontSize} * 0.9)`
        })}>
            <Trans
                i18nKey="ios_install"
                components={[
                    <IosShareOutlined fontSize="small"/>
                ]}
            />
        </Typography>}

    </Alert>
}

export default InstallPwaBanner